<template>
  <div class="relative">
    <button v-if="areaLevel === 'school' && $store.getters.isLogin" class="mb-2 lg:mb-0 bg-grey-lightest hover:bg-grey-lighter text-black text-xs font-bold py-2 px-3 rounded flex items-center mr-2" @mouseover="isShowMutationSelection = true">
      <v-icon scale="1.2" class="self-center text-button-icon" name="expand-arrows-alt" />
    </button>
    <div class="mb-2 lg:mb-0 bg-white py-2 px-3 w-32 rounded border absolute pin-b pin-l flex flex-col z-1010" v-if="isShowMutationSelection" @mouseleave="isShowMutationSelection = false">
      <label class="text-black font-bold flex items-center">
        <input class="mr-1" type="checkbox" :checked="isShowOneZone" @click="toggleShowOneZone">
        <span class="text-sm">
          Satu zona
        </span>
      </label>
      <!-- <label class="text-black font-bold flex items-center">
        <input class="mr-1" type="checkbox" v-model="isShowCrossLevel">
        <span class="text-sm">
          Antar jenjang
        </span>
      </label> -->
      <label class="text-black font-bold flex items-center">
        <input class="mr-1" type="checkbox" :checked="isShowCrossZone" @click="toggleShowCrossZone">
        <span class="text-sm">
          Antar zona
        </span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mutation-filter',
  props: {
    areaLevel: String,
    isShowOneZone: Boolean,
    isShowCrossZone: Boolean,
    toggleShowOneZone: Function,
    toggleShowCrossZone: Function
  },
  data () {
    return {
      isShowMutationSelection: false
    }
  }
}
</script>
